import cloneDeep from 'lodash.clonedeep';
import {
  JurisdictionArea,
  JurisdictionAreaGridData
} from './jurisdictionArea.types';
import { AccessFunction } from '../accessFunction/accessFunction.types';

export function adaptJurisdictionAreaListToGrid(
  jurisdictionAreas: JurisdictionArea[],
  accessFunctions: AccessFunction[],
): JurisdictionAreaGridData[] {
  const regex = /=/g;

  const adaptedJurisdictionAreas: JurisdictionAreaGridData[] = jurisdictionAreas.map((jurisdictionArea: JurisdictionArea) => {
    const af = accessFunctions.find((accessFunction) => accessFunction.id === (window.btoa(jurisdictionArea.AFID)).replace(regex, ''));
    const adaptedJurisdictionArea: JurisdictionAreaGridData = cloneDeep({
      ...jurisdictionArea,
      AFTYPE: af ? af.type : '',
      AFNAME: af ? af.name : '',
    })
    return adaptedJurisdictionArea;
  })

  return adaptedJurisdictionAreas;
}
